import React, {useState} from 'react';
import {useSelector} from "react-redux";
import moment from "moment";
import {word} from "../../word.js";
import {Col, Modal, Row} from "react-bootstrap";
import Loader from "../BlueButton/Loader.js";
import {TextField} from "@mui/material";
import Button from "../Button/Button.js";
import Api from "../../Api.js"
function AddNote({onHide, show}) {
    const [title, setTitle] = useState("");
    const [endDate, setEndDate] = useState(new Date());
    const employee = useSelector((state) => state.manager.employee);

    const [emptyError, setEmptyError] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleNewNote();
        }
    };

    const handleChangeDate = (e) => {
        setEndDate(e.target.value);
    };

    const handleNewNote = async () => {
        try {
            setSubmitted(true);
            setDisabled(true);

            if (title.length > 0) {
                const data = {
                    title: title,
                    end_date: moment(endDate).format("YYYY-MM-DD"),
                    accountant: employee.url,
                };
                await Api.addNote(data)
                await onHide()
            } else {
                setDisabled(false);
            }
        }catch (e) {
            console.log(e)
            setDisabled(false);

        }
    };
    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered


        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span/>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                    <div className="container">
                        <Row className="d-flex justify-content-around">
                            <Col xs={12} sm={10} className="align-items-sm-center">
                                <div className="input-validation w-100">
                                    <TextField
                                        id="datetime-local"
                                        label="Վերջնաժամկետ"
                                        type="datetime-local"
                                        onChange={handleChangeDate}
                                        variant="outlined"
                                        InputProps={{ inputProps: { min: moment(new Date()).format("YYYY-MM-DDTHH:mm") } }}
                                        sx={{ width: 250 }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                                <div className={title.length === 0 && submitted ? "input-validation input-validation-valid  w-100" : "w-100 input-validation"}>
                            <textarea
                                className="note-input"
                                name="title"
                                value={title}
                                onKeyDown={handleKeyPress}
                                onChange={(e) => {
                                    setTitle(e.target.value);
                                    if (e.target.value.length === 0) {
                                        setEmptyError("Կատարել նշումներ");
                                    } else {
                                        setEmptyError("");
                                    }
                                }}
                                placeholder="Կատարել նշումներ"
                            />
                                    {title.length === 0 && <div className="validation">{emptyError}</div>}
                                </div>

                                {disabled && (
                                    <div className="disable-loader">
                                        <Loader size={30} />
                                    </div>
                                )}

                                <Button
                                    disabled={disabled}
                                    buttonStyle="blue-button"
                                    onChangeValue={handleNewNote}
                                    title={word.save}
                                />
                            </Col>
                        </Row>
                    </div>
            </Modal.Body>
        </Modal>
    );
}

export default AddNote;